<template>
    <div>
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4">
                            <br>
                            <a href="/event/home">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left" />
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>参加者リスト</b>
                            </div>
                        </div>
                        <div class="col-4">
                        </div>
                    </div>
                </div>
            </div>

            <div class="wrap container" style="margin-top:60px;">
                <div class="row" style="padding: 20px 0;">
                    <div class="col">
                        <div style="padding:10px 10px;">
                            <div>
                                申込人数：{{ event_members.length }}人
                            </div>
                        </div>
                    </div>
                    <div class="col text-end">
                        <a type="button" class="btn btn-luna-outline" @click="showListModal()"
                            style="padding:8px 12px;border-radius: 3px;font-size:14px">
                            出演者毎の申込数
                        </a>
                    </div>
                </div>

                <div class="row" style="overflow-x: scroll;">
                    <div class="col px-0 table-responsive" style="font-size:14px;">
                        <table class="table text-nowrap table-borderless">
                            <thead style="background:#C6C4FF">
                                <tr>
                                    <td scope="col" colspan="6" style="color:#5538EE;padding:15px 0;">
                                        <span style="padding-left: 75px;">
                                            <svg style="height:16px;width:16px;fill:#5538EE;">
                                                <use xlink:href="/images/swipe.svg#swipe" />
                                            </svg>
                                            <span style="margin-left: 5px;">
                                                スワイプで表が左右に移動します
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td scope="col" style="min-width: 70px;">受付番号</td>
                                    <td scope="col" style="min-width: 120px;">ユーザ名</td>
                                    <td class="col text-center" style="min-width: 60px;">性別</td>
                                    <td class="col text-center" style="min-width: 70px;">性癖</td>
                                    <td class="col text-center" style="min-width: 100px;">出演者毎の申込数</td>
                                    <td class="col" style="min-width: 150px;">メールアドレス</td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    v-for="member in event_members"
                                    :key="member.id"
                                    class="align-middle"
                                    :class="{
                                        'cancel': isCancel(member.is_event)
                                    }"
                                >
                                    <td class="text-center" :class="isCancel(member.is_event) ? 'cancel' : 'reception'">
                                        {{ member.id }}
                                        <span v-if="isCancel(member.is_event)" style="font-size:10px;color:#777;display:block;">
                                            キャンセル
                                        </span>
                                    </td>

                                    <td>{{ member.name }}</td>

                                    <td class="col-1 text-center">
                                        {{ getSexLabel(member.sex) }}
                                    </td>

                                    <td class="text-center">
                                        <span :class="[
                                            'fetish-type-badge',
                                            {
                                                'sadist': member.type === 1,
                                                'masochist': member.type === 2,
                                                'switch-role': member.type === 3
                                            }
                                        ]">
                                            {{ getFetishLabel(member.type) }}
                                        </span>
                                    </td>


                                    <td class="col-1 text-center">
                                        <span v-if="member.player_name === null">-</span>
                                        <span v-else>{{ member.player_name }}</span>
                                    </td>

                                    <td class="col-1 text-center">
                                        <span>{{ member.mail }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <modal name="modal-list" :draggable="false" :resizable="false" width="300px" height="500px">
                <div class="container">
                    <div class="row">
                        <div class="col px-0" style="height:500px;overflow-y: scroll;">
                            <div class="text-center" style="padding:15px 0;color:#5538EE">出演者毎の申込数</div>

                            <table class="table text-nowrap table-borderless">
                                <thead>
                                    <tr style="background:#C6C4FF">
                                        <td scope="col">出演者名</td>
                                        <td scope="col">人数</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(member, index) in player_counts" :key="index">
                                        <td scope="col">{{ member.player_name }}</td>
                                        <td scope="col">{{ member.count }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            event_members: [],
            player_counts: [],
        };
    },
    methods: {
        showListModal() {
            this.$modal.show('modal-list');
        },
        hideListModal() {
            this.$modal.hide('modal-list');
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.fetchEventMember(this.$route.params['eid'])
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchEventMember(eid) {
            await axios.get("/api/event/admin/member/list/" + eid)
                .then(
                    (response) => {
                        this.event_members = response.data.event_members
                        this.player_counts = response.data.player_counts
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("管理者の取得に失敗しました")
                    }
                })
        },
        isCancel(is_event) {
            return is_event === 4
        },
        getSexLabel(sex) {
            switch (sex) {
                case 1: return '女';
                case 2: return '男';
                default: return '不明';
            }
        },
        getFetishLabel(type) {
            switch (type) {
                case 1: return 'S';
                case 2: return 'M';
                default: return 'スイッチ';
            }
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
            }
        }
        else {
            this.isAuth()
        }
    },
};
</script>

<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

.cancel {
    background: #ddd;
}

.reception {
    background: #E7E7FF;
}

.fetish-type-badge {
    display: block;
    color: #fff;
    padding: 8px;
    border-radius: 6px;
}

.sadist {
    background: #1DA1F2;
}

.masochist {
    background: #FF6D6D;
}

.switch-role {
    background: #F6BF30;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
